export default {
  pt: {
    'category.none': 'Sem tipo',
    'category.espiga': 'Espiga',
    'category.granel': 'Granel',
    'category.prancha': 'Prancha',
    'category.tanque': 'Tanque',
    'category.cacamba': 'Caçamba',
    'category.carvao': 'Carvão',
    'category.fazenda': 'Fazenda',
    // O ERP chama de Frota Leve o veículo que o HUB tipa com o code `utilitario`.
    // O rótulo acompanha o ERP; o code não muda.
    'category.utilitario': 'Frota Leve',
    'category.trailer': 'Carreta',
    'category.maquina': 'Máquina',
    'category.driver': 'Motorista',
    'category.operator': 'Operador',
    'category.producer': 'Produtor',
    'category.farm': 'Pivô',
    'category.headquarters': 'Apoio/Sede',
    'category.unit': 'Unidade',
    'category.grain': 'Grão',
    'category.part': 'Peça',
    'category.other': 'Outro',
    'category.colheita_transporte': 'Colheita e Transporte',
    'category.colheita': 'Colheita',
    'category.transporte': 'Transporte',
    'category.movimentacao_maquina': 'Movimentação de Máquina',
  },
  en: {
    'category.none': 'No type',
    'category.espiga': 'Ear',
    'category.granel': 'Bulk',
    'category.prancha': 'Flatbed',
    'category.tanque': 'Tanker',
    'category.cacamba': 'Dump',
    'category.carvao': 'Charcoal',
    'category.fazenda': 'Farm',
    'category.utilitario': 'Light fleet',
    'category.trailer': 'Trailer',
    'category.maquina': 'Machine',
    'category.driver': 'Driver',
    'category.operator': 'Operator',
    'category.producer': 'Grower',
    'category.farm': 'Field',
    'category.headquarters': 'Support/HQ',
    'category.unit': 'Facility',
    'category.grain': 'Grain',
    'category.part': 'Part',
    'category.other': 'Other',
    'category.colheita_transporte': 'Harvest and Transport',
    'category.colheita': 'Harvest',
    'category.transporte': 'Transport',
    'category.movimentacao_maquina': 'Machine Movement',
  },
  es: {
    'category.none': 'Sin tipo',
    'category.espiga': 'Espiga',
    'category.granel': 'Granel',
    'category.prancha': 'Plataforma',
    'category.tanque': 'Cisterna',
    'category.trailer': 'Remolque',
    'category.maquina': 'Máquina',
    'category.driver': 'Conductor',
    'category.operator': 'Operador',
    'category.producer': 'Productor',
    'category.farm': 'Pivote',
    'category.headquarters': 'Apoyo/Sede',
    'category.unit': 'Unidad',
    'category.grain': 'Grano',
    'category.part': 'Pieza',
    'category.other': 'Otro',
    'category.colheita_transporte': 'Cosecha y Transporte',
    'category.colheita': 'Cosecha',
    'category.transporte': 'Transporte',
    'category.movimentacao_maquina': 'Movimiento de Máquina',
  },
}
